// extracted by mini-css-extract-plugin
export default {"container":"GDPR_container__xw44Q","inner-wrapper":"GDPR_inner-wrapper__dxEfs"};